import { FieldWrapper, Label, Textarea } from '@commenda/kakashi';
import { TSysAgentStepAttachment } from '@commenda/types';
import { useState } from 'react';

import { AgentStepAttachmentsField } from './AgentStepAttachmentsField';

interface AgentStepResourcesFieldProps {
  resourceText: string | undefined;
  attachments: TSysAgentStepAttachment[];
  onResourceTextChange: (resourceText: string | undefined) => void;
  onAttachmentsChange: (
    attachments: TSysAgentStepAttachment[] | undefined
  ) => void;
}

export const AgentStepResourcesField = ({
  resourceText,
  attachments,
  onResourceTextChange,
  onAttachmentsChange,
}: AgentStepResourcesFieldProps) => {
  const [draft, setDraft] = useState(resourceText ?? '');

  return (
    <FieldWrapper>
      <Label optional>Reference material</Label>
      <p className="txt-extra-small-regular text-text-secondary">
        Handed to the agent on <strong>every</strong>&nbsp;run, without it
        asking. It is treated as data, not as instructions — the agent is told
        not to follow anything written here.
      </p>

      <Textarea
        rows={4}
        value={draft}
        placeholder="Anything the agent should have in front of it: context about this engagement, figures to work from..."
        onChange={(event) => {
          setDraft(event.target.value);
          onResourceTextChange(
            event.target.value.trim() ? event.target.value : undefined
          );
        }}
      />

      <AgentStepAttachmentsField
        attachments={attachments}
        onChange={onAttachmentsChange}
      />

      <p className="txt-extra-small-regular mt-xs text-text-secondary">
        A file&apos;s text is read the moment it is attached, so nothing can
        fail during a run later.
      </p>
    </FieldWrapper>
  );
};
